import React, { useState } from "react";
import { AnouncementSchema } from "../../../schema/schema";
import { apiCall } from "../../../API/apiCall";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";

import Loader from "../../loader/Loader";

const Announcement = () => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
  });

  const [isLoader, setIsLoader] = useState(false);

  const [formError, setFormError] = useState({});

  const onChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const trimmedTitle = formData.title?.trim();
    const trimmedDescription = formData.description?.trim();

    const error = AnouncementSchema({
      title: trimmedTitle,
      description: trimmedDescription,
    });

    if (Object.keys(error).length !== 0) {
      setFormError(error);
      return;
    }

    try {
      setIsLoader(true);
      const response = await apiCall({
        url: "/blogs/announcement",
        method: "POST",
        data: {
          title: trimmedTitle,
          description: trimmedDescription,
        },
      });

      if (response.status === true) {
        setFormData({
          title: "",
          description: "",
        });
        setFormError({});
        toast.success(response.message);
      }

      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
    }
  };

  return (
    <>
      {isLoader && <Loader />}

      <div className="main-content-gap px-3">
        <h2 className="topHeading">Announcement</h2>
        <div className="form-section">
          <h2 className="mb-5 text-center">Announcement Form</h2>
          <form onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="announcementInput1">Announcement Title</label>
              <input
                type="text"
                className={`form-control mb-4 ${
                  formError.title ? "is-invalid" : ""
                }`}
                id="announcementInput1"
                name="title"
                value={formData.title}
                onChange={onChange}
                placeholder="Write your title"
              />
              {formError.title && (
                <div className="invalid-feedback">{formError.title}</div>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="announcementInput2">
                Announcement Description
              </label>
              <textarea
                className={`form-control mb-4 ${
                  formError.description ? "is-invalid" : ""
                }`}
                id="announcementInput2"
                rows={5}
                placeholder="Write your description"
                name="description"
                value={formData.description}
                onChange={onChange}
              ></textarea>
              {formError.description && (
                <div className="invalid-feedback">{formError.description}</div>
              )}
            </div>
            <Button
              variant="contained"
              type="submit"
              className="btn btn-primary ml-auto"
            >
              Send
            </Button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Announcement;
